import PropTypes from 'prop-types';
import EventVisualisationControllerImpl from './event-visualisation-controller.jsx';
import MojitoCore from 'mojito/core';
const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Event scoreboard/stream component associated with the specified event.
 * It displays a TabbedPane with two sections, one for the scoreboard and another for the video stream.
 * The scoreboard component interchangeably uses Statscore or Mojito depending on the availability of Statscore.
 * When there is no stream available, only the scoreboard is displayed and the tabs are not shown.
 *
 * @example <caption>Setting the default tab:</caption>
 * The "Scores" tab is selected by default. It's possible to change the default tab using the YAML file:
 *
 *   tabButtons:
 *     defaultSelectedTab: 'stream' # Can be either 'scores' or 'stream'
 *
 * @class EventVisualisationController
 * @name Visualisation
 * @memberof Mojito.Modules
 */

/**
 * `EventVisualisationController` prop types.
 *
 * @property {string} event - Represents the event to be visualised.
 *
 * @memberof Mojito.Modules.Visualisation
 */
const propTypes = {
    event: PropTypes.object.isRequired,
};

export default UIControllerView(
    'EventVisualisationController',
    EventVisualisationControllerImpl,
    propTypes
);
